import type { SVGProps } from "react";

export function IconWhiteBarrier(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      {...props}
    >
      <path
        d="M16 46V57"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M48 46V57"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
      <path
        d="M48 25V34M57 13V25H45M57 13L45 25M57 13H38M7 25V13H19M7 25H26M7 25L19 13M26 25H45M26 25L38 13M57 34V46H45M57 34H38M57 34L45 46M7 46V34H19M7 46L19 34M7 46H26M38 34H19M38 34L26 46M16 46V57M16 25V34M48 46V57M26 46H45M38 13H19M51 10C51 11.6569 49.6569 13 48 13C46.3431 13 45 11.6569 45 10C45 8.34315 46.3431 7 48 7C49.6569 7 51 8.34315 51 10ZM19 10C19 11.6569 17.6569 13 16 13C14.3431 13 13 11.6569 13 10C13 8.34315 14.3431 7 16 7C17.6569 7 19 8.34315 19 10Z"
        stroke="#23232C"
        strokeWidth="1.5"
        strokeLinecap="square"
      />
    </svg>
  );
}
